/**
 * Created by pyt on 2017-03-07.
 */
import { FilterComparisonOperator } from '@/common/models';
import FilterBase from '@/common/models/query-params/FilterBase';

import Filter from './Filter';
import * as ComparisonOperator from './FilterComparisonOperator';
import LogicalOperator from './FilterLogicalOperator.enum';

export default class UUIDFilter extends FilterBase {
  type: string;
  property: string;
  values: Array<string>;
  comparisonOperator: string;
  logicalOperator: string;
  label: string;
  private instance: any;

  constructor(property = null, label = null, values = null) {
    super();
    this.type = 'UUIDFilter';
    this.property = property;
    this.values = values;
    this.comparisonOperator = ComparisonOperator.EQUAL;
    this.logicalOperator = LogicalOperator.OR;
    this.label = label;
  }

  get isEmpty() {
    return this.value == null;
  }

  get value() {
    return this.values == null ? null : this.values.join(', ');
  }

  static isValid(value) {
    if (value == null) return false;
    return value.match(/\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/gm) != null;
  }

  getFilters() {
    return [new Filter(this.property, this.values, FilterComparisonOperator.EQUAL)];
  }

  clear() {
    this.values = null;
  }

  serializeForQueryString() {
    return `${this.property}~${this.values != null ? this.values.join('~') : ''}`;
  }

  static deserializeFromQueryString(filter, serialized) {
    const fragments = serialized.split('~');
    const instance = new UUIDFilter(filter.property, filter.label, fragments.slice(1));
    return instance;
  }

  toApi() {
    return {
      property: this.property,
      label: this.label,
      values: this.values,
    };
  }

  static fromApi(apiObject) {
    const filter = new UUIDFilter(apiObject.property, apiObject.label, apiObject.values);
    filter.instance = apiObject.instance;
    return filter;
  }
}
